import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Icon, Menu, Dropdown, Carousel, Breadcrumb, Tooltip, message, Modal, Button } from 'antd';
import { withTranslation } from 'react-i18next';
import {
  TabMenuContainer,
  TabMenuItemContainer,
  SettingsList,
  SettingsHeading,
  SettingsListCard,
  LoaderContainer,
  HelpGuideWrapper,
  DropdownDetails,
  TabMenuItemDetails,
  EmptySettingsDetails,
  TemplatePageOverview,
  TabMenuHeaderContainer,
  SubTabHeading,
  BreadCrumbHeading,
  PageCountIndicator,
  ModalBody,
} from './styles';

import EmptyElementsIllustration from '../../images/empty-elements.svg';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import { FolderSvg } from '../../components/SidebarMenuIcons';
import ApplyTemplate from '../../components/ApplyTemplate';
import EditorElement from './EditorElementWrapper';
import ComplexEditorElement from '../../components/EditorElement';
import Loader from '../../components/Loader';
import DeleteFolderModal from '../../components/Modals/DeleteFolderModal';
import CreateFolderModal from '../../components/Modals/CreateFolderModal';
import PreviewModal from '../../components/Modals/PreviewModal';
import { getallFolder, addFolderElement } from '../../utils/services/folderAPI';
import { getSelectedTemplate } from '../../utils/services/templatesAPI';
import { getSelectedMailTemplates } from '../../utils/services/mailTemplateAPI';
import { getSelectedDocument, getSelectedStandAloneFlow, getSelectedStandAloneBlock } from '../../utils/services/complexDocumentsAPI';
import { AppStoreContext } from '../../context/appStoreContext';
import { correctBaseUrl } from '../../utils/svgUtils';
import { DESIGN_AREA_FOLDERS_TAB } from './translationValues';
import { ApplyTemplateBtn, ApplyTemplateBtnContainer } from '../../components/ApplyTemplate/styles';
import {
  DESIGN_AREA_TEMPLATES_TAB,  
} from './../../containers/SidebarMenu/translationValues';
import URL from '../../utils/helper';
import _ from 'underscore';

const NAMESPACES = ['DESIGN_AREA_FOLDERS_TAB']
class FolderTabDetails extends Component {
  constructor(props) {
    super(props);
    this.previousContext = null;
    this.state = {
      isLoading: true,
      isEditable: false,
      isRemove: false,
      rootId: null,
      modalVisible: false,
      deletemodalVisible: false,
      targetFolder: {},
      treeIndexs: [],
      count: 0,
      templatesData: [],
      selectedView: 'view-templates',
      selectedTemplate: null,
      replaceTemplate: null,
      element: '',
      breadCrumb: [{ key: -1, name: this.props.t(DESIGN_AREA_FOLDERS_TAB.HOME_ACTION.key, DESIGN_AREA_FOLDERS_TAB.HOME_ACTION.value) }],
      previewModalVisible: false,
      pageId: 0,
      resourceGroup: null,
      isSaving: false,
      replaceModalVisibility: false,
      isTemplateSaved: false,
    };
  }

  static contextType = AppStoreContext;

  async componentDidMount() {
    const { updateListofFolders, folderList } = this.context;
    this.previousContext = folderList;
    let currentResGroup = this.props.isEmail
      ? this.props.template?.resourceGroupId
      : this.props.template?.resourceGroup;
    const elementType = this.props.elementType; 
    let folderResponse = await getallFolder(
      this.props.isEmail,
      this.props.isShortMessage,
      true,
      this.props.isSaveFolder && currentResGroup,
      elementType
    );
    updateListofFolders(folderResponse.data, 'fetchAllFolders');
    this.setState({
      isLoading: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { folderList } = this.context;
    if (this.previousContext !== folderList) {
      let selectedElements = this.renderFolders();
      let elements = selectedElements.elements;
      elements && this.fetchingTemplatesData({ elements });
    }
    this.previousContext = folderList;
  }

  handleFolderSelect = async (data, key) => {
    const { resourceGroup, id } = data;
    const { breadCrumb, treeIndexs } = this.state;
    let ref_indexes = treeIndexs;
    let ref_breadCrumb = breadCrumb;
    ref_breadCrumb.push({ key: key, name: data.name });
    ref_indexes.push(key);
    this.setState(previousState => {
      return {
        rootId: id,
        count: previousState.count + 1,
        breadCrumb: ref_breadCrumb,
        treeIndexs: ref_indexes,
        resourceGroup,
      };
    });
    this.fetchingTemplatesData(data);
  };

  fetchingTemplatesData = async data => {
    let templateResponse,
      ids,
      elementArray = [];
    this.setState({ isLoading: true });
    let templateId = data.elements.map(value => {
      elementArray.push(value);
      return value.elementId;
    });
    if (templateId.length === 0) {
      this.setState({ templatesData: templateId });
    } else {
      ids = templateId.toString();

      if (this.props.isEmail) {
        templateResponse = await getSelectedMailTemplates(ids);
      }
      else if (this.props.elementType === 'document') {
        templateResponse = await getSelectedDocument(ids)
      }
      else if (this.props.elementType === 'flow') {
        templateResponse = await getSelectedStandAloneFlow(ids)
      }
      else if (this.props.elementType === 'block') {
        templateResponse = await getSelectedStandAloneBlock(ids)
      } 
      else {
        templateResponse = await getSelectedTemplate(ids);
      }

      this.setState({
        templatesData: templateResponse.data,
        element: elementArray,
        isLoading: false,
      });
    }
    const openedTemplate = window.location.pathname.split('/');
    const currentTemplateId = this.props.template?.mailTemplateId || this.props.template?.id || openedTemplate[2]
    const isTemplateSaved = templateId.includes(currentTemplateId);
    this.setState({
      isLoading: false,
      isTemplateSaved
    });
  };

  handleDeleteFolder = data => {
    this.setState({
      deletemodalVisible: true,
      targetFolder: data,
      isRemove: false,
    });
  };

  handleEditFolder = data => {
    this.setState({
      modalVisible: true,
      isEditable: true,
      targetFolder: data,
    });
  };

  handlePreviousData = () => {
    const { count, breadCrumb, treeIndexs } = this.state;
    let fetchedFolders;
    let ref_breadCrumb = breadCrumb;
    ref_breadCrumb.pop();
    let ref_indexes = treeIndexs;
    ref_indexes.pop();
    this.setState(previousState => {
      if (previousState.count - 1 === 0) {
        return {
          count: previousState.count - 1,
          rootId: null,
          breadCrumb: ref_breadCrumb,
          treeIndexs: [],
          resourceGroup: null,
        };
      } else {
        return {
          count: previousState.count - 1,
          rootId: fetchedFolders.id,
          breadCrumb: ref_breadCrumb,
          treeIndexs: ref_indexes,
        };
      }
    });

    if (count - 1 !== 0) {
      fetchedFolders = this.renderFolders();
      let elements = fetchedFolders.elements;
      elements && this.fetchingTemplatesData({ elements });
    } else {
      return 0;
    }
  };

  onSuccess = async (status, responseId, payload) => {
    const { targetFolder, templatesData, rootId } = this.state;
    const { updateListofFolders } = this.context;
    switch (status) {
      case 'folder deleted successfully':
        updateListofFolders(targetFolder, 'deleteFolder', responseId);
        this.setState({
          deletemodalVisible: false,
        });
        break;

      case 'Template deleted successfully':
        let filterTemplate;
        filterTemplate = templatesData.filter(data => data.id !== targetFolder?.elementId);
        updateListofFolders(targetFolder, 'deleteFolderTemplate', rootId);
        this.setState({
          templatesData: filterTemplate,
          deletemodalVisible: false,
          isRemove: false,
        });
        break;

      case 'folder created successfully':
        payload.id = responseId;
        payload.subFolder = [];
        payload.elements = [];
        updateListofFolders(payload, 'createNewFolder', responseId);
        this.setState({
          modalVisible: false,
        });
        break;

      case 'folder updated successfully':
        payload.subFolder = targetFolder.subFolder;
        payload.elements = targetFolder.elements;
        updateListofFolders(payload, 'updateFolder', responseId);
        this.setState({
          modalVisible: false,
        });
        break;

      case 'FolderElement Added Succesfully':
        payload.id = responseId;
        const openedTemplate = window.location.pathname.split('/');
        let currentResGroup = this.props.isEmail
          ? this.props.template?.resourceGroupId
          : this.props.template?.resourceGroup;
        const elementType = this.props.elementType;
        let folderResponse = await getallFolder(
          openedTemplate[1] === 'emailDesign' ? true : false,
          this.props.isShortMessage,
          true,
          currentResGroup,
          elementType
        );
        updateListofFolders(folderResponse.data, 'fetchAllFolders');
        break;
      default:
        this.setState({
          modalVisible: false,
          deletemodalVisible: false,
        });
    }
  };

  generateDocumentThumbnail = (documentId) => `${URL.DESIGN_SYSTEM_URL}dynamic/thumbnail/${documentId}`;
  generateFlowThumbnail = (id) => `${URL.DESIGN_SYSTEM_URL}standalone/flow/thumbnail/${id}`;
  generateBlockThumbnail = (id) => `${URL.DESIGN_SYSTEM_URL}standalone/block/thumbnail/${id}`;

  renderThumbnail = (templateObj) => {
    const elementType = this.props.elementType;
        if (elementType === "flow") {
      return (
        <img
          src={templateObj.thumbnail ? templateObj.thumbnail : this.generateFlowThumbnail(templateObj.id)}
          alt="pageObj-thumbnail"
        />
      )
    } else if (elementType === "block") {
      return (
        <img
          src={templateObj.thumbnail ? templateObj.thumbnail : this.generateFlowThumbnail(templateObj.id)}
          alt="pageObj-thumbnail"
        />
      )
    }
    else if (elementType === "document") {
      const thumbnail = templateObj.flows[0]?.thumbnail;
      return (
        <img
          src={thumbnail ? thumbnail : this.generateFlowThumbnail(templateObj.id)}
          alt="pageObj-thumbnail"
        />
      )
    }
    else {
      return (
        <img
          src={
            templateObj.thumbNailUrl
              ? correctBaseUrl(templateObj.thumbNailUrl)
              : PageNotFoundIllustration
          }
          alt="pageObj-thumbnail"
          className={templateObj.thumbNailUrl ? 'no-thumbnail' : ''}
        />
      )
    }
  }

  enableModalVisibility = () => {
    this.setState({ modalVisible: true, isEditable: false, targetFolder: '' });
  };

  changeSelectedView = (staus, data) => {
    this.setState({
      selectedView: staus,
      selectedTemplate: data,
    });
  };

  removeTemplateHandler = data => {   
    const { element } = this.state;
    const { isEmail } = this.props;
    let target;
    element.map(value => {
      if (value.elementId === (isEmail ? data.mailTemplateId : this.props.elementType === 'email_block' ? data?.parentBlockId : data.id )) {
        target = value;
      }
      return target;
    });
  
    this.setState({
      isRemove: true,
      targetFolder: target,
      deletemodalVisible: true,
      selectedView: 'view-templates',
    });
  };

  redirectToTemplate = template => { 
      this.props.history.push(`/design/${template.id}`); 
  };

  topNavigation = key => {
    const { breadCrumb, treeIndexs, resourceGroup } = this.state;
    let ref_breadCrumb = breadCrumb.slice(0, key + 1);
    let ref_indexes = treeIndexs.slice(0, key);
    this.setState({
      count: key,
      breadCrumb: ref_breadCrumb,
      treeIndexs: ref_indexes,
    });
    setTimeout(() => {
      let fetchedFolders = this.renderFolders();
      let elements = fetchedFolders.elements;
      elements && this.fetchingTemplatesData({ elements });
      this.setState({
        rootId: key === 0 ? null : fetchedFolders.id,
        resourceGroup: key === 0 ? null : resourceGroup,
      });
    }, 100);
  };

  previewModalVisibility = (e, template, pageIndex) => {
    e.stopPropagation();
    this.setState({ previewModalVisible: true, pageId: pageIndex, selectedTemplate: template });
  };

  renderFolders = () => {
    const { treeIndexs } = this.state;
    const { folderList } = this.context;
    let selectedList = folderList;
    treeIndexs.map((item, index) => {
      if (index === 0) {
        selectedList = selectedList[item];
      } else {
        selectedList = selectedList.subFolder[item];
      }
      return selectedList;
    });
    return selectedList;
  };

  saveTemplate = async data => {
    const { rootId } = this.state;
    this.setState({
      isSaving: true,
    });
    const openedTemplate = window.location.pathname.split('/');
    let payload = {
      folderId: rootId,
      elementId:
        this.props.template?.mailTemplateId || this.props.template?.id || openedTemplate[2],
      name: this.props.template?.name,
      thumbnail: correctBaseUrl(this.props.template?.thumbNailUrl || this.props.template?.thumbnail),
      elementType:
        this.props.template?.type === 'client'
          ? 'emailTemplate' : this.props.elementType ? this.props.elementType
          : this.props.template?.type || 'usertemplate',
    };     
    let response = await addFolderElement(payload);
    if (response && response.errors && response.errors.length === 0) {
      // message.success(response.status);
      let responseStatus = 'FolderElement Added Succesfully';
      this.onSuccess(responseStatus, response.id, payload);
      message.success(this.props.t(DESIGN_AREA_FOLDERS_TAB.FOLDER_ADDED_SUCCESS_MESSAGE.key, DESIGN_AREA_FOLDERS_TAB.FOLDER_ADDED_SUCCESS_MESSAGE.value));
    }
    this.setState({
      isSaving: false,
    });
  };

  debouncedHandleApplyAllFlows = _.debounce((selectedTemplate) => {
    this.props.handleApplyAllFlows(selectedTemplate);
  }, 500);

  render() {
    const {
      isLoading,
      deletemodalVisible,
      targetFolder,
      modalVisible,
      isEditable,
      rootId,
      count,
      templatesData,
      selectedView,
      selectedTemplate,
      isRemove,
      breadCrumb,
      treeIndexs,
      previewModalVisible,
      replaceModalVisibility,
      replaceTemplate,
      pageId,
      resourceGroup,
      isSaving,
      isTemplateSaved
    } = this.state;
    const { isSaveFolder, isEmail, t, elementType } = this.props;
    const fetchedFolders = this.renderFolders();

    return (
      <TabMenuContainer isSaveFolder={isSaveFolder} disabled={!this.props.editable}>
        {isLoading && (
          <LoaderContainer>
            <Loader />
            <div className="loading-txt">{t(DESIGN_AREA_FOLDERS_TAB.LOADING_FOLDERS.key, DESIGN_AREA_FOLDERS_TAB.LOADING_FOLDERS.value)}</div>
          </LoaderContainer>
        )}
        {!isLoading &&
          count === 0 &&
          treeIndexs.length === 0 &&
          selectedView === 'view-templates' &&
          fetchedFolders && (
            <SettingsList>
              <SettingsHeading folder={isSaveFolder}>
                {isSaveFolder ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Icon type="left" onClick={this.props.handlePrevious} />
                    <div>
                      {t(DESIGN_AREA_FOLDERS_TAB.FOLDERS_TITLE.key, DESIGN_AREA_FOLDERS_TAB.FOLDERS_TITLE.value) + ' '} 
                      ({fetchedFolders.length})
                    </div>
                  </div>
                ) : (
                  <div>
                    {t(DESIGN_AREA_FOLDERS_TAB.FOLDERS_TITLE.key, DESIGN_AREA_FOLDERS_TAB.FOLDERS_TITLE.value) + ' '} 
                    ({fetchedFolders.length})
                  </div>
                )}
                {isSaveFolder && (
                  <Tooltip title={t(DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_FOLDER_TOOLTIP.key, DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_FOLDER_TOOLTIP.value)} placement="right">
                    <div onClick={this.enableModalVisibility}>
                      <Icon type="plus" style={{ cursor: 'pointer', fontSize: '16px' }} />
                    </div>
                  </Tooltip>
                )}
              </SettingsHeading>
              {fetchedFolders.length > 0 &&
                fetchedFolders.map((value, index) => {
                  return (
                    <SettingsListCard
                      key={index}
                      onClick={() => this.handleFolderSelect(value, index)}
                    >
                      <div className="settings-list-icon">
                        <Icon component={FolderSvg} style={{ color: '#000' }} />
                      </div>
                      <div className="settings-list-meta">
                        <div className="settings-list-name">{value.name}</div>
                        <div className="settings-list-details">
                          {t(DESIGN_AREA_FOLDERS_TAB.SUB_FOLDERS_COUNT_LABEL.key, DESIGN_AREA_FOLDERS_TAB.SUB_FOLDERS_COUNT_LABEL.value)} : {value.subFolder.length} | {t(DESIGN_AREA_FOLDERS_TAB.TEMPLATES_COUNT_LABEL.key, DESIGN_AREA_FOLDERS_TAB.TEMPLATES_COUNT_LABEL.value)} :{' '}
                          {value.elements.length}
                        </div>
                      </div>
                      <DropdownDetails
                        id={`${value.id}-folder`}
                        className="dropdown-menu dropdown-visible"
                        onClick={e => e.stopPropagation()}
                        vertical
                      >
                        <Dropdown
                          trigger={['click']}
                          getPopupContainer={() => document.getElementById(`${value.id}-folder`)}
                          overlay={
                            <Menu>
                              <Menu.Item key="0" onClick={() => this.handleEditFolder(value)}>
                                {t(DESIGN_AREA_FOLDERS_TAB.EDIT_FOLDER_DROPDOWN_OPTION.key, DESIGN_AREA_FOLDERS_TAB.EDIT_FOLDER_DROPDOWN_OPTION.value)}
                              </Menu.Item>
                              <Menu.Item key="1" onClick={() => this.handleDeleteFolder(value)}>
                                {t(DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_DROPDOWN_OPTION.key, DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_DROPDOWN_OPTION.value)}
                              </Menu.Item>
                            </Menu>
                          }
                        >
                          <Icon type="more" />
                        </Dropdown>
                      </DropdownDetails>
                    </SettingsListCard>
                  );
                })}
            </SettingsList>
          )}
        <div>
          {!isLoading &&
            count !== 0 &&
            treeIndexs.length > 0 &&
            selectedView === 'view-templates' &&
            fetchedFolders && (
              <BreadCrumbHeading folder={isSaveFolder}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Icon type="left" onClick={() => this.handlePreviousData()} />
                  <Breadcrumb>
                    {breadCrumb.map((obj, index) => {
                      return (
                        <Breadcrumb.Item key={obj.key} onClick={() => this.topNavigation(index)}>
                          {obj.name}
                        </Breadcrumb.Item>
                      );
                    })}
                  </Breadcrumb>
                </div>
                {isSaveFolder && (
                  <Tooltip title={t(DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_SUB_FOLDER_TOOLTIP.key, DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_SUB_FOLDER_TOOLTIP.value)} placement="right">
                    <div onClick={this.enableModalVisibility}>
                      <Icon type="plus" style={{ cursor: 'pointer', fontSize: '16px' }} />
                    </div>
                  </Tooltip>
                )}
              </BreadCrumbHeading>
            )}
          {!isLoading &&
            count !== 0 &&
            selectedView === 'view-templates' &&
            fetchedFolders &&
            fetchedFolders.subFolder.map((value, index) => {
              return (
                <SettingsListCard key={index} onClick={() => this.handleFolderSelect(value, index)}>
                  <div className="settings-list-icon">
                    <Icon component={FolderSvg} style={{ color: '#000' }} />
                  </div>
                  <div className="settings-list-meta">
                    <div className="settings-list-name">{value.name}</div>
                    <div className="settings-list-details">
                      {t(DESIGN_AREA_FOLDERS_TAB.SUB_FOLDERS_COUNT_LABEL.key, DESIGN_AREA_FOLDERS_TAB.SUB_FOLDERS_COUNT_LABEL.value)} : {value.subFolder.length} | {t(DESIGN_AREA_FOLDERS_TAB.TEMPLATES_COUNT_LABEL.key, DESIGN_AREA_FOLDERS_TAB.TEMPLATES_COUNT_LABEL.value)} : {value.elements.length}
                    </div>
                  </div>
                  <DropdownDetails
                    id={`${value.id}-folder`}
                    className="dropdown-menu dropdown-visible"
                    onClick={e => e.stopPropagation()}
                    vertical
                  >
                    <Dropdown
                      trigger={['click']}
                      getPopupContainer={() => document.getElementById(`${value.id}-folder`)}
                      overlay={
                        <Menu>
                          <Menu.Item key="0" onClick={() => this.handleEditFolder(value)}>
                            {t(DESIGN_AREA_FOLDERS_TAB.EDIT_FOLDER_DROPDOWN_OPTION.key, DESIGN_AREA_FOLDERS_TAB.EDIT_FOLDER_DROPDOWN_OPTION.value)}
                          </Menu.Item>
                          <Menu.Item key="1" onClick={() => this.handleDeleteFolder(value)}>
                            {t(DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_DROPDOWN_OPTION.key, DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_DROPDOWN_OPTION.value)}
                          </Menu.Item>
                        </Menu>
                      }
                    >
                      <Icon type="more" />
                    </Dropdown>
                  </DropdownDetails>
                </SettingsListCard>
              );
            })}
          {!isLoading &&
            count !== 0 &&
            selectedView === 'view-templates' &&
            templatesData?.length > 0 && (
              <>
                <TabMenuHeaderContainer>
                  <TabMenuItemContainer>
                    {templatesData.map(templateObj => {
                      return (
                        <TemplatePageOverview
                          key={templateObj.id}
                          title={templateObj.name}
                          onClick={() => {
                            if (!isSaveFolder) {
                             ( isEmail || ['emailTemplate', 'email_block'].includes(this.props.elementType))
                                ? this.setState({
                                    replaceModalVisibility: true,
                                    replaceTemplate: templateObj,
                                  })
                                : !['flow', "block"].includes(elementType) && this.changeSelectedView('view-template-pages', templateObj);
                            }
                          }}
                        >
                          <div className="template-media">
                            <div className="image-wrapper">
                              <Carousel autoplay dots={false}>
                                {templateObj.pages ? (
                                  templateObj.pages.length > 0 &&
                                  templateObj.pages.map(pageObj => {
                                    return (
                                      <div key={pageObj.pageId}>
                                        <img
                                          src={
                                            pageObj.thumbnail
                                              ? correctBaseUrl(pageObj.thumbnail)
                                              : PageNotFoundIllustration
                                          }
                                          alt="pageObj-thumbnail"
                                          className={!pageObj.thumbnail ? 'no-thumbnail' : ''}
                                        />
                                      </div>
                                    );
                                  })
                                ) : (                 
                                  <div>
                                    {this.renderThumbnail(templateObj)};                               
                                  </div>
                                )}
                              </Carousel>
                            </div>
                            {!isEmail && !['document','flow','block',"emailTemplate",'email_block'].includes(this.props.elementType) && (
                              <PageCountIndicator>
                                <div className="page-counter">
                                  {templateObj.pages.length}{' '}
                                  {templateObj.pages.length > 1
                                    ? t(
                                      DESIGN_AREA_FOLDERS_TAB.PAGES_NUM.key,
                                      DESIGN_AREA_FOLDERS_TAB.PAGES_NUM.value,
                                    )
                                  : t(
                                      DESIGN_AREA_FOLDERS_TAB.PAGE_NUM.key,
                                      DESIGN_AREA_FOLDERS_TAB.PAGE_NUM.value,
                                    )}
                                </div>
                              </PageCountIndicator>
                            )}
                            <Tooltip title={t(DESIGN_AREA_FOLDERS_TAB.TEMPLATE_PREVIEW_TOOLTIP.key, DESIGN_AREA_FOLDERS_TAB.TEMPLATE_PREVIEW_TOOLTIP.value)} placement="top">
                              <div
                                className="preview-button"
                                onClick={e => this.previewModalVisibility(e, templateObj, 0)}
                              >
                                <Icon type="eye" />
                              </div>
                            </Tooltip>
                            <DropdownDetails
                              id={`${templateObj.id}-template`}
                              className="dropdown-menu"
                              onClick={e => e.stopPropagation()}
                            >
                              <Dropdown
                                trigger={['click']}
                                getPopupContainer={() =>
                                  document.getElementById(`${templateObj.id}-template`)
                                }
                                overlay={
                                  <Menu>
                                    {!isEmail && (
                                      <Menu.Item
                                        key="0"
                                        onClick={() => this.redirectToTemplate(templateObj)}
                                      >
                                        {t(DESIGN_AREA_FOLDERS_TAB.EDIT_FOLDER_DROPDOWN_OPTION.key, DESIGN_AREA_FOLDERS_TAB.EDIT_FOLDER_DROPDOWN_OPTION.value)}
                                      </Menu.Item>
                                    )}
                                    <Menu.Item
                                      key="1"
                                      onClick={() => this.removeTemplateHandler(templateObj)}
                                    >
                                      {t(DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_FROM_FOLDER_DROPDOWN_OPTION.key, DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_FROM_FOLDER_DROPDOWN_OPTION.value)}
                                    </Menu.Item>
                                  </Menu>
                                }
                              >
                                <Icon type="more" />
                              </Dropdown>
                            </DropdownDetails>
                          </div>
                          <div className="template-name">
                            <h2>{templateObj?.name || templateObj?.parentBlockName}</h2>
                          </div>
                        </TemplatePageOverview>
                      );
                    })}
                  </TabMenuItemContainer>
                </TabMenuHeaderContainer>
              </>
            )}
          {!isLoading && selectedView === 'view-template-pages' && selectedTemplate && (
            <div>
              <SubTabHeading className="with-icon">
                <Icon type="left" onClick={() => this.changeSelectedView('view-templates', null)} />
                <div className="subtab-name">{selectedTemplate.name}</div>
                <DropdownDetails
                  id={`${selectedTemplate.id}-template`}
                  className="dropdown-menu dropdown-visible"
                  onClick={e => e.stopPropagation()}
                >
                  <Dropdown
                    trigger={['click']}
                    getPopupContainer={() =>
                      document.getElementById(`${selectedTemplate.id}-template`)
                    }
                    overlay={
                      <Menu>
                        <Menu.Item
                          key="0"
                          onClick={() => this.redirectToTemplate(selectedTemplate)}
                        >
                          {t(DESIGN_AREA_FOLDERS_TAB.EDIT_FOLDER_DROPDOWN_OPTION.key, DESIGN_AREA_FOLDERS_TAB.EDIT_FOLDER_DROPDOWN_OPTION.value)}
                        </Menu.Item>
                        <Menu.Item
                          key="1"
                          onClick={() => this.removeTemplateHandler(selectedTemplate)}
                        >
                          {t(DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_FROM_FOLDER_DROPDOWN_OPTION.key, DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_FROM_FOLDER_DROPDOWN_OPTION.value)}
                        </Menu.Item>
                      </Menu>
                    }
                  >
                    <Icon type="more" />
                  </Dropdown>
                </DropdownDetails>
              </SubTabHeading>

              {this.props.elementType === 'document' ? <>
                <ApplyTemplateBtnContainer>
                  <ApplyTemplateBtn onClick={() => this.debouncedHandleApplyAllFlows(selectedTemplate)}>{t(DESIGN_AREA_TEMPLATES_TAB.APPLY_ALL_PAGES_BUTTON.key, DESIGN_AREA_TEMPLATES_TAB.APPLY_ALL_PAGES_BUTTON.value)}</ApplyTemplateBtn>
                </ApplyTemplateBtnContainer>
                {selectedTemplate && selectedTemplate.flows?.length > 0 &&
                  <ComplexEditorElement
                    element={selectedTemplate}
                    clickElement={() => { }}
                    toggleDragging={() => { }}
                    pageSettings={{}}
                    setIsDragAndDropped={() => { }}
                    type={"replaceFlow"}
                    cardType='replaceFlow'
                  />
                } 
              </> : <>
                <ApplyTemplate template={selectedTemplate} />
                {selectedTemplate && selectedTemplate.pages.length > 0 ? (
                  <TabMenuItemContainer>
                    {selectedTemplate.pages.map((pageObj, index) => {
                      let pageDetails = {
                        name: '',
                        thumbnail: correctBaseUrl(pageObj.thumbnail),
                        type: 'colored',
                        elementDetails: pageObj,
                        actionType: 'replace-template-page',
                        isTemplate: true
                      };
                      return (
                        <TabMenuItemDetails key={pageObj.pageId} type="page" size="big">
                          <EditorElement element={pageDetails} />
                          <PageCountIndicator>
                            <div className="page-counter">{t(DESIGN_AREA_FOLDERS_TAB.PAGE_NUM.key, DESIGN_AREA_FOLDERS_TAB.PAGE_NUM.value) + ' '} {index + 1} </div>
                          </PageCountIndicator>
                          <Tooltip title={t(DESIGN_AREA_FOLDERS_TAB.TEMPLATE_PREVIEW_TOOLTIP.key, DESIGN_AREA_FOLDERS_TAB.TEMPLATE_PREVIEW_TOOLTIP.value)} placement="top">
                            <div
                              className="preview-button"
                              onClick={e => this.previewModalVisibility(e, selectedTemplate, index)}
                            >
                              <Icon type="eye" />
                            </div>
                          </Tooltip>
                        </TabMenuItemDetails>
                      );
                    })}
                  </TabMenuItemContainer>
                ) : (
                  <div></div>
                )}
              </>}
            </div>
          )}
          {!isLoading && count === 0 && fetchedFolders.length === 0 && (
            <EmptySettingsDetails emptyfolder>
              <div className="empty-illustration">
                <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
              </div>
              <div className="empty-txt">
                <span>{t(DESIGN_AREA_FOLDERS_TAB.FOLDERS_LIST_EMPTY.key, DESIGN_AREA_FOLDERS_TAB.FOLDERS_LIST_EMPTY.value)}</span>
                <span className="empty-links" onClick={this.enableModalVisibility}>
                {t(DESIGN_AREA_FOLDERS_TAB.HERE.key, DESIGN_AREA_FOLDERS_TAB.HERE.value)}
                </span>
                <span>{t(DESIGN_AREA_FOLDERS_TAB.EMPTY_LIST_CREATE_NEW_FOLDER.key, DESIGN_AREA_FOLDERS_TAB.EMPTY_LIST_CREATE_NEW_FOLDER.value)}</span>
              </div>
            </EmptySettingsDetails>
          )}
          {!isLoading &&
            count !== 0 &&
            fetchedFolders &&
            fetchedFolders.elements.length === 0 &&
            fetchedFolders.subFolder.length === 0 && (
              <EmptySettingsDetails>
                <div className="empty-illustration">
                  <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
                </div>
                <div className="empty-txt">
                  <span>{t(DESIGN_AREA_FOLDERS_TAB.EMPTY_FOLDERS.key, DESIGN_AREA_FOLDERS_TAB.EMPTY_FOLDERS.value)}</span>
                </div>
              </EmptySettingsDetails>
            )}
        </div>
        {!isSaveFolder && (
          <HelpGuideWrapper complexDesign={true}>
            <div className="help-container">
              {rootId !== null &&
                <div className="help-action-btn" onClick={!isTemplateSaved && this.saveTemplate}>
                  {isTemplateSaved
                    ? t(DESIGN_AREA_FOLDERS_TAB.FOLDER_SAVED.key, DESIGN_AREA_FOLDERS_TAB.FOLDER_SAVED.value)
                    : isSaving
                      ? t(DESIGN_AREA_FOLDERS_TAB.SAVING_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.SAVING_BUTTON.value)
                      : t(DESIGN_AREA_FOLDERS_TAB.SAVE_TO_FOLDER.key, DESIGN_AREA_FOLDERS_TAB.SAVE_TO_FOLDER.value)}
                </div>}

              <div className="help-action-btn" onClick={this.enableModalVisibility}>
                <Icon type="plus" />{' '}
                {rootId === null
                  ? t(
                      DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_FOLDER_BUTTON.key,
                      DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_FOLDER_BUTTON.value,
                    )
                  : t(
                    DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_SUB_FOLDER_BUTTON.key,
                    DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_SUB_FOLDER_BUTTON.value,
                  )}
              </div>
            </div>
          </HelpGuideWrapper>
        )}
        {isSaveFolder && rootId !== null && (
          <HelpGuideWrapper isSaveFolder={isSaveFolder} isTemplateSaved={isTemplateSaved}>
            <div className="help-container">
              <Button
                className="help-action-btn"
                onClick={() => {
                  !isTemplateSaved && this.saveTemplate()
                }}
                loading={isSaving}
              >
                {isTemplateSaved
                  ? t(DESIGN_AREA_FOLDERS_TAB.FOLDER_SAVED.key, DESIGN_AREA_FOLDERS_TAB.FOLDER_SAVED.value)
                  : isSaving
                    ? t(DESIGN_AREA_FOLDERS_TAB.SAVING_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.SAVING_BUTTON.value)
                    : t(DESIGN_AREA_FOLDERS_TAB.SAVE_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.SAVE_BUTTON.value)}
              </Button>
            </div>
          </HelpGuideWrapper>
        )}
        {deletemodalVisible && (
          <DeleteFolderModal
            visible={deletemodalVisible}
            onCancel={this.onSuccess}
            target={targetFolder}
            removeTemplate={isRemove}
            folderName={breadCrumb[count].name}
          />
        )}
        {modalVisible && (
          <CreateFolderModal
            visible={modalVisible}
            onCancel={this.onSuccess}
            isEditable={isEditable}
            target={targetFolder}
            parentId={rootId}
            resourceGroup={resourceGroup}
          />
        )}
        {previewModalVisible &&
          <PreviewModal
            isMailTemplates={isEmail}
            visible={previewModalVisible}
            onCancel={() => this.setState({ previewModalVisible: false })}
            targetTemplate={selectedTemplate}
            currentIndex={pageId}
          />
        }
        {replaceModalVisibility && (
          <Modal
            title={t(DESIGN_AREA_FOLDERS_TAB.REPLACE_TEMPLATE_MODAL_TITLE.key, DESIGN_AREA_FOLDERS_TAB.REPLACE_TEMPLATE_MODAL_TITLE.value)}
            centered
            visible={replaceModalVisibility}
            width="625px"
            onCancel={() => this.setState({ replaceModalVisibility: false })}
            footer={[
              <Button key="back" onClick={() => this.setState({ replaceModalVisibility: false })}>
                {t(DESIGN_AREA_FOLDERS_TAB.REPLACE_TEMPLATE_NO_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.REPLACE_TEMPLATE_NO_BUTTON.value)}
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => {
                  this.setState({ replaceModalVisibility: false });
                  this.props.replaceEmailTemplate(replaceTemplate);
                }}
              >
                {t(DESIGN_AREA_FOLDERS_TAB.REPLACE_TEMPLATE_YES_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.REPLACE_TEMPLATE_YES_BUTTON.value)}
              </Button>,
            ]}
            className="warning-modal"
          >
            <ModalBody>
              <div className="warning-text">
                <span>{t(DESIGN_AREA_FOLDERS_TAB.REPLACE_TEMPLATE_CONFIRMATION.key, DESIGN_AREA_FOLDERS_TAB.REPLACE_TEMPLATE_CONFIRMATION.value)}</span>
              </div>
            </ModalBody>
          </Modal>
        )}
      </TabMenuContainer>
    );
  }
}

export default withTranslation(NAMESPACES)(withRouter(FolderTabDetails));
